const constants = {
    AdminFavouriteUsers: [
        'SPOTIFYBLOKUR',
        'WARNERBLOKUR',
        'DND_PUBLIC_USER',
        'CTMBVBLOKUR',
        'MLCBLOKUR',
        'IMPELBLOKUR',
        'UMPGBLOKUR',
        'KOBALTBLOKUR',
    ],
    EntityType: {
        NONE: 0,
        WRITER: 1,
        PUBLISHER: 2,
        UNKNOWN: 3,
        ANY: 4,
    },
    UserSourceTypes: {
        SOCIETY: 'SO',
        PUBLISHER: 'PB',
        MUSIC: 'M', // for music distributors, e.g. Spotify
        BLOKUR: 'BK',
    },
    WorkCatalogueTypes: {
        SOURCE: 'SOURCE', // user has provided source for the work
        MENTION: 'MENTION', // user has been mentioned by another source in the work
        TERRITORY_MATCH: 'TERRITORY_MATCH', // society user's default country matches the country for the work
        ALL_WORKS: 'ALL_WORKS', // user can view any and all works on the platform (music users)
        ONLY_META: 'ONLY_META', // meta only work
    },
    ShareType: {
        NONE: 0,
        PERFORMANCE: 1,
        MECHANICAL: 2,
        BOTH: 3,
    },
    ShareView: {
        NONE: 0,
        STATE: 1,
        SOURCE: 2,
        EITHER: 3,
    },
    ToastTypes: {
        SUCCESS: 'success',
        INFO: 'info',
        WARNING: 'warning',
        ERROR: 'error',
    },
    ToastDurations: {
        SHORT: 3000,
        LONG: 6000,
        DEFAULT: 10000,
    },
    NotificationsStatusType: {
        OK: 'OK',
        ERROR: 'error',
    },
    SearchFilters: ['iswc', 'title', 'writers', 'publishers', 'ipi', 'isrcs', 'artist_names'],
    SearchSorters: ['popularity'],
    HoverIPIs: {
        NONE: -1,
        DISPUTED: -2,
    },
    ClaimRoles: {
        CLAIMANT: 0,
        DEFENDANT: 1,
    },
    ActivityActions: {
        INVALID: 0,
        STATE_CREATED: 'STATE_CREATED',
        STATE_ADDED: 'STATE_ADDED',
        STATE_UPDATED: 'STATE_UPDATED',
        STATE_DELETED: 'STATE_DELETED',
    },
    HttpCodes: {
        // 2XX  SUCCESS
        OK: 200,
        CREATED: 201,
        // 3XX  REDIRECTION
        MOVED_PERMANENTLY: 301,
        // 4XX  CLIENT ERROR
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        METHOD_NOT_ALLOWED: 405,
        UNSUPPORTED_MEDIA_TYPE: 415,
        TOO_MANY_REQUESTS: 429,
        // 5XX SERVER ERROR
        INTERNAL_SERVER_ERROR: 500,
        NOT_IMPLEMENTED: 501,
        BAD_GATEWAY: 502,
        SERVICE_UNAVAILABLE: 503,
    },
    ACLPermissions: {
        works: {
            GET: 'works:GET',
            UPLOAD: 'works:UPLOAD',
            ACCEPT_STATE: 'works:ACCEPT_STATE',
            UNDO_ACCEPT_STATE: 'works:UNDO_ACCEPT_STATE',
            REMOVE_USER_MENTION: 'works:REMOVE_USER_MENTION',
        },
        claims: {
            GET: 'claims:GET',
            CREATE: 'claims:CREATE',
            RESPOND: 'claims:RESPOND',
            WITHDRAW: 'claims:WITHDRAW',
            ACCEPT: 'claims:ACCEPT',
            REVIEW_EVIDENCE: 'claims:REVIEW_EVIDENCE',
            AUTO_ACCEPT: 'claims:AUTO_ACCEPT',
            REVIEW: 'claims:REVIEW',
        },
        auth: {
            RESET_PASSWORD: 'auth:RESET_PASSWORD',
            PROXY_AUTH: 'auth:PROXY_AUTH',
        },
        users: {
            GET: 'users:GET',
            UPDATE: 'users:UPDATE',
            CREATE: 'users:CREATE',
        },
        notifications: {
            GET: 'notifications:GET',
            READ: 'notifications:READ',
        },
        charts: {
            GET: 'charts:GET',
        },
        messages: {
            GET: 'messages:GET',
            CREATE: 'messages:CREATE',
            RESPOND: 'messages:RESPOND',
        },
        licenses: {
            GET: 'licenses:GET',
            CREATE: 'licenses:CREATE',
        },
        royalties: {
            GET: 'royalties:GET',
        },
    },
    ServerCodes: {
        CONNECTION_REFUSED: 'ECONNREFUSED',
        TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    },
    AllCountryISOAlpha2Codes: {
        4: 'AF',
        8: 'AL',
        12: 'DZ',
        20: 'AD',
        24: 'AO',
        28: 'AG',
        31: 'AZ',
        32: 'AR',
        36: 'AU',
        40: 'AT',
        44: 'BS',
        48: 'BH',
        50: 'BD',
        51: 'AM',
        52: 'BB',
        56: 'BE',
        64: 'BT',
        68: 'BO',
        70: 'BA',
        72: 'BW',
        76: 'BR',
        84: 'BZ',
        90: 'SB',
        96: 'BN',
        100: 'BG',
        // 104: 'BU', Burma, other name for Myanmar
        104: 'MM',
        108: 'BI',
        112: 'BY',
        116: 'KH',
        120: 'CM',
        124: 'CA',
        132: 'CV',
        140: 'CF',
        144: 'LK',
        148: 'TD',
        152: 'CL',
        156: 'CN',
        158: 'TW',
        170: 'CO',
        174: 'KM',
        178: 'CG',
        // 180: 'ZR', Congo
        180: 'CD',
        188: 'CR',
        191: 'HR',
        192: 'CU',
        196: 'CY',
        200: 'CS',
        203: 'CZ',
        204: 'BJ',
        208: 'DK',
        212: 'DM',
        214: 'DO',
        218: 'EC',
        222: 'SV',
        226: 'GQ',
        230: 'ET',
        231: 'ET',
        232: 'ER',
        233: 'EE',
        242: 'FJ',
        246: 'FI',
        250: 'FR',
        258: 'PF',
        262: 'DJ',
        266: 'GA',
        268: 'GE',
        270: 'GM',
        276: 'DE',
        278: 'DD',
        280: 'DE',
        288: 'GH',
        296: 'KI',
        300: 'GR',
        308: 'GD',
        320: 'GT',
        324: 'GN',
        328: 'GY',
        332: 'HT',
        336: 'VA',
        340: 'HN',
        344: 'HK',
        348: 'HU',
        352: 'IS',
        356: 'IN',
        360: 'ID',
        364: 'IR',
        368: 'IQ',
        372: 'IE',
        376: 'IL',
        380: 'IT',
        384: 'CI',
        388: 'JM',
        392: 'JP',
        398: 'KZ',
        400: 'JO',
        404: 'KE',
        408: 'KP',
        410: 'KR',
        414: 'KW',
        417: 'KG',
        418: 'LA',
        422: 'LB',
        426: 'LS',
        428: 'LV',
        430: 'LR',
        434: 'LY',
        438: 'LI',
        440: 'LT',
        442: 'LU',
        450: 'MG',
        454: 'MW',
        458: 'MY',
        462: 'MV',
        466: 'ML',
        470: 'MT',
        478: 'MR',
        480: 'MU',
        484: 'MX',
        492: 'MC',
        496: 'MN',
        498: 'MD',
        499: 'ME',
        504: 'MA',
        508: 'MZ',
        512: 'OM',
        516: 'NA',
        520: 'NR',
        524: 'NP',
        528: 'NL',
        540: 'NC',
        548: 'VU',
        554: 'NZ',
        558: 'NI',
        562: 'NE',
        566: 'NG',
        578: 'NO',
        583: 'FM',
        584: 'MH',
        585: 'PW',
        586: 'PK',
        591: 'PA',
        598: 'PG',
        600: 'PY',
        604: 'PE',
        608: 'PH',
        616: 'PL',
        620: 'PT',
        624: 'GW',
        626: 'TL',
        630: 'PR',
        634: 'QA',
        642: 'RO',
        643: 'RU',
        646: 'RW',
        659: 'KN',
        662: 'LC',
        670: 'VC',
        674: 'SM',
        678: 'ST',
        682: 'SA',
        686: 'SN',
        688: 'RS',
        690: 'SC',
        694: 'SL',
        702: 'SG',
        703: 'SK',
        704: 'VN',
        705: 'SI',
        706: 'SO',
        710: 'ZA',
        716: 'ZW',
        720: 'YD',
        724: 'ES',
        728: 'SS',
        729: 'SD',
        732: 'EH',
        736: 'SD',
        740: 'SR',
        748: 'SZ',
        752: 'SE',
        756: 'CH',
        760: 'SY',
        762: 'TJ',
        764: 'TH',
        768: 'TG',
        776: 'TO',
        780: 'TT',
        784: 'AE',
        788: 'TN',
        792: 'TR',
        795: 'TM',
        798: 'TV',
        800: 'UG',
        804: 'UA',
        807: 'MK',
        810: 'SU',
        818: 'EG',
        826: 'GB',
        834: 'TZ',
        840: 'US',
        854: 'BF',
        858: 'UY',
        860: 'UZ',
        862: 'VE',
        882: 'WS',
        886: 'YE',
        887: 'YE',
        890: 'YU',
        // 891: 'YU', Yugoslavia was a country
        891: 'CS',
        894: 'ZM',
        2100: '2AF',
        2101: '2AM',
        2102: '2AC',
        2103: '2AN',
        2104: '2AP',
        2105: '2AE',
        2106: '2AS',
        2107: '2AA',
        2108: '2BA',
        2109: '2BS',
        2110: '2BE',
        2111: '2BI',
        2112: '2BW',
        2113: '2CA',
        2114: '2CO',
        2115: '2CF',
        2116: '2CS',
        2117: '2CU',
        2118: '2CI',
        2119: '2EE',
        2120: '2EU',
        2121: '2EM',
        2122: '2EC',
        // 2123: '2EY',
        2123: '2EN',
        2124: '2GC',
        2125: '2ME',
        2126: '2NT',
        2127: '2NC',
        2128: '2NF',
        2129: '2NA',
        2130: '2OC',
        2131: '2SC',
        2132: '2SA',
        2133: '2SE',
        2134: '2WI',
        2136: 'WW',
    },
    CountryISOAlpha2Codes: {
        2136: 'WW', //Worldwide
        840: 'US', // United States
        392: 'JP', // Japan
        826: 'GB', // United Kingdom
        276: 'DE', // Germany
        250: 'FR', // France
        124: 'CA', // Canada
        36: 'AU', // Australia
        410: 'KR', // South Korea
        380: 'IT', // Italy
        528: 'NL', // Netherlands
        752: 'SE', // Sweden
        724: 'ES', // Spain
        40: 'AT', // Austria
        756: 'SW', //Switzerland
        156: 'CN',
        76: 'BR',
    },
    CountryISOAlpha2toName: {
        WW: 'Worldwide',
        US: 'United States',
        JP: 'Japan',
        GB: 'United Kingdom',
        DE: 'Germany',
        FR: 'France',
        CA: 'Canada',
        AU: 'Australia',
        KR: 'South Korea',
        IT: 'Italy',
        NL: 'Netherlands',
        SE: 'Sweden',
        ES: 'Spain',
        AT: 'Austria',
        SW: 'Switzerland',
        CN: 'CHINA',
        BR: 'BRAZIL',
    },
    AllCountryISOAlpha2toName: {
        WW: 'Worldwide',
        AF: 'AFGHANISTAN',
        AL: 'ALBANIA',
        DZ: 'ALGERIA',
        AD: 'ANDORRA',
        AO: 'ANGOLA',
        AG: 'ANTIGUA+BARBUDA',
        AZ: 'AZERBAIJAN',
        AR: 'ARGENTINA',
        AU: 'AUSTRALIA',
        AT: 'AUSTRIA',
        BS: 'BAHAMAS',
        BH: 'BAHRAIN',
        BD: 'BANGLADESH',
        AM: 'ARMENIA',
        BB: 'BARBADOS',
        BE: 'BELGIUM',
        BT: 'BHUTAN',
        BO: 'BOLIVIA',
        BA: 'BOSNIA+HERZEGO.',
        BW: 'BOTSWANA',
        BR: 'BRAZIL',
        BZ: 'BELIZE',
        SB: 'SOLOMON ISLANDS',
        BN: 'BRUNEI',
        BG: 'BULGARIA',
        BU: 'BURMA',
        MM: 'MYANMAR',
        BI: 'BURUNDI',
        BY: 'BELARUS',
        KH: 'CAMBODIA',
        CM: 'CAMEROON',
        CA: 'CANADA',
        CV: 'CAPE VERDE',
        CF: 'CENT.AFRIC.REP.',
        LK: 'SRI LANKA',
        TD: 'CHAD',
        CL: 'CHILE',
        CN: 'CHINA',
        TW: 'TAIWAN',
        CO: 'COLOMBIA',
        KM: 'COMOROS',
        CG: 'CONGO',
        ZR: 'ZAIRE',
        CD: 'DEMOC.REP.CONGO',
        CR: 'COSTA RICA',
        HR: 'CROATIA',
        CU: 'CUBA',
        CY: 'CYPRUS',
        // CS: 'CZECHOSLOVAKIA', Code element CS was used for the former Czechoslovakia (CS, CSK, 200) then reused for Serbia and Montenegro
        CZ: 'CZECH REPUBLIC',
        BJ: 'BENIN',
        DK: 'DENMARK',
        DM: 'DOMINICA',
        DO: 'DOMINICAN REP.',
        EC: 'ECUADOR',
        SV: 'EL SALVADOR',
        GQ: 'EQUAT.GUINEA',
        ET: 'ETHIOPIA',
        ER: 'ERITREA',
        EE: 'ESTONIA',
        FJ: 'FIJI',
        FI: 'FINLAND',
        FR: 'FRANCE',
        PF: 'FR.POLYNESIA',
        DJ: 'DJIBOUTI',
        GA: 'GABON',
        GE: 'GEORGIA',
        GM: 'GAMBIA',
        DD: 'GDR',
        DE: 'GERMANY',
        GH: 'GHANA',
        KI: 'KIRIBATI',
        GR: 'GREECE',
        GD: 'GRENADA',
        GT: 'GUATEMALA',
        GN: 'GUINEA',
        GY: 'GUYANA',
        HT: 'HAITI',
        VA: 'VATICAN',
        HN: 'HONDURAS',
        HK: 'HONG KONG',
        HU: 'HUNGARY',
        IS: 'ICELAND',
        IN: 'INDIA',
        ID: 'INDONESIA',
        IR: 'IRAN',
        IQ: 'IRAQ',
        IE: 'IRELAND',
        IL: 'ISRAEL',
        IT: 'ITALY',
        CI: "COTE D'IVOIRE",
        JM: 'JAMAICA',
        JP: 'JAPAN',
        KZ: 'KAZAKHSTAN',
        JO: 'JORDAN',
        KE: 'KENYA',
        KP: 'NORTH KOREA',
        KR: 'SOUTH KOREA',
        KW: 'KUWAIT',
        KG: 'KYRGYZSTAN',
        LA: 'LAO',
        LB: 'LEBANON',
        LS: 'LESOTHO',
        LV: 'LATVIA',
        LR: 'LIBERIA',
        LY: 'LIBYA',
        LI: 'LIECHTENSTEIN',
        LT: 'LITHUANIA',
        LU: 'LUXEMBOURG',
        MG: 'MADAGASCAR',
        MW: 'MALAWI',
        MY: 'MALAYSIA',
        MV: 'MALDIVES',
        ML: 'MALI',
        MT: 'MALTA',
        MR: 'MAURITANIA',
        MU: 'MAURITIUS',
        MX: 'MEXICO',
        MC: 'MONACO',
        MN: 'MONGOLIA',
        MD: 'MOLDOVA',
        ME: 'MONTENEGRO',
        MA: 'MOROCCO',
        MZ: 'MOZAMBIQUE',
        OM: 'OMAN',
        NA: 'NAMIBIA',
        NR: 'NAURU',
        NP: 'NEPAL',
        NL: 'NETHERLANDS',
        NC: 'NEW CALEDONIA',
        VU: 'VANUATU',
        NZ: 'NEW ZEALAND',
        NI: 'NICARAGUA',
        NE: 'NIGER',
        NG: 'NIGERIA',
        NO: 'NORWAY',
        FM: 'MICRONESIA',
        MH: 'MARSHALL ISL.',
        PW: 'PALAU',
        PK: 'PAKISTAN',
        PA: 'PANAMA',
        PG: 'PAPUA N.GUINEA',
        PY: 'PARAGUAY',
        PE: 'PERU',
        PH: 'PHILIPPINES',
        PL: 'POLAND',
        PT: 'PORTUGAL',
        GW: 'GUINEA-BISSAU',
        TL: 'TIMOR-LESTE',
        PR: 'PUERTO RICO',
        QA: 'QATAR',
        RO: 'ROMANIA',
        RU: 'RUSSIA',
        RW: 'RWANDA',
        KN: 'ST.KITTS+NEVIS',
        LC: 'ST.LUCIA',
        VC: 'ST.VINCENT+GR',
        SM: 'SAN MARINO',
        ST: 'S.TOME+PRINCIPE',
        SA: 'SAUDI ARABIA',
        SN: 'SENEGAL',
        RS: 'SERBIA',
        SC: 'SEYCHELLES',
        SL: 'SIERRA LEONE',
        SG: 'SINGAPORE',
        SK: 'SLOVAKIA',
        VN: 'VIET NAM',
        SI: 'SLOVENIA',
        SO: 'SOMALIA',
        ZA: 'SOUTH AFRICA',
        ZW: 'ZIMBABWE',
        YD: 'DEMOCRAT.YEMEN',
        ES: 'SPAIN',
        SS: 'SOUTH SUDAN',
        SD: 'SUDAN',
        EH: 'WESTERN SAHARA',
        SR: 'SURINAME',
        SZ: 'SWAZILAND',
        SE: 'SWEDEN',
        CH: 'SWITZERLAND',
        SY: 'SYRIA',
        TJ: 'TAJIKISTAN',
        TH: 'THAILAND',
        TG: 'TOGO',
        TO: 'TONGA',
        TT: 'TRINIDAD+TOBAGO',
        AE: 'UNIT.ARAB.EMIR.',
        TN: 'TUNISIA',
        TR: 'TURKEY',
        TM: 'TURKMENISTAN',
        TV: 'TUVALU',
        UG: 'UGANDA',
        UA: 'UKRAINE',
        MK: 'MACEDONIA',
        SU: 'USSR',
        EG: 'EGYPT',
        GB: 'UNITED KINGDOM',
        TZ: 'TANZANIA',
        US: 'USA',
        BF: 'BURKINA FASO',
        UY: 'URUGUAY',
        UZ: 'UZBEKISTAN',
        VE: 'VENEZUELA',
        WS: 'SAMOA',
        YE: 'YEMEN',
        YU: 'YUGOSLAVIA',
        CS: 'SERBIA+MONTENE.',
        ZM: 'ZAMBIA',
        '2AF': 'AFRICA',
        '2AM': 'AMERICA',
        '2AC': 'AMERICAN CONT.',
        '2AN': 'ANTILLES',
        '2AP': 'APEC',
        '2AE': 'ASEAN',
        '2AS': 'ASIA',
        '2AA': 'AUSTRALASIA',
        '2BA': 'BALKANS',
        '2BS': 'BALTIC STATES',
        '2BE': 'BENELUX',
        '2BI': 'BRITISH ISLES',
        '2BW': 'BRIT.WEST IND.',
        '2CA': 'CENTRAL AMERICA',
        '2CO': 'COMMONWEALTH',
        '2CF': 'CO AFRICA',
        '2CS': 'CO ASIA',
        '2CU': 'CO AUSTRALASIA',
        '2CI': 'CIS',
        '2EE': 'EASTERN EUROPE',
        '2EU': 'EUROPE',
        '2EM': 'EUROP.ECON.AREA',
        '2EC': 'EUROPEAN CONT.',
        '2EY': 'EEC',
        '2EN': 'EUROPEAN UNION',
        '2GC': 'GSA',
        '2ME': 'MIDDLE EAST',
        '2NT': 'NAFTA',
        '2NC': 'NORDIC COUNTR.',
        '2NF': 'NORTH AFRICA',
        '2NA': 'NORTH AMERICA',
        '2OC': 'OCEANIA',
        '2SC': 'SCANDINAVIA',
        '2SA': 'SOUTH AMERICA',
        '2SE': 'SOUTH EAST ASIA',
        '2WI': 'WEST INDIES',
    },
    TopCountriesbyMarketShare: [
        // Taken from the IFPI 2019 Global Music Report
        840, // US
        392, // Japan
        826, // UK
        276, // Germany
        250, // France
        410, // South Korea
        156, // China
        36, // Australia
        124, // Canada
        76, // Brazil
    ],
    PublisherAliases: {
        UMG: [
            'UNIVERSAL MUSIC PUBLISHING (FRANCE) SAS',
            'CAPITOL CMG GENESIS',
            'UNIVERSAL MUSIC-Z TUNES LLC',
            'UNIVERSAL MCA MUSIC PUBLISHING',
            'UNIVERSAL - MCA MUSIC PUBLISHING',
            'UNIVERSAL JJ RECORDS',
            'SONGS OF UNIVERSAL',
            'UNIVERSAL MUSIC PUB. GROUP',
            'UNIVERSAL MUSIC PUBLISHING (UK) LTD',
            'UNIVERSAL MUSIC-MGB SONGS',
            'UNIVERSAL MUSIC PUBLISHING BV',
            'RONDOR MUSIKVERLAG GMBH',
            'UNIVERSAL MUSIC PUBLISHING INTERNATIONAL LTD',
            'UNIVERSAL/DICK JAMES MUSIC LIMITED',
            'ARABELLA MUSIKVERLAG GMBH',
            'UNIVERSAL MUSIC PUBLISHING AB',
            'UNIVERSAL GEFFEN MUSIC',
            'UNIVERSAL/MCA MUSIC SCAND AB',
            'UNIVERSAL MUSIC PUBLISHING MGB HOLDING BV',
            'UNIVERSAL MUSIC PUBLISHING LLC',
            'UNIVERSAL MUSIC PUBLISHING MGB LIMITED',
            'UNIVERSAL MUSIC INDIA LTD',
            'UNIVERSAL MUSIC PUBLISHING RICORDI SRL',
            'CAPITOL CMG PARAGON',
            'ALMO-MUSIC CORPORATION',
            'UNIVERSAL MUSIC CORP',
            'UNIVERSAL MUSIC PUBLISHING MGB SCANDINAVIA AB',
            'UNIVERSAL MUSIC Z SONGS',
            'UNIVERSAL MUSIC PUBLISHING PTY LTD',
            'UNIVERSAL MUSIC PUBLISHING LTD. (U.K.)',
            'UNIVERSAL MUSIC BRENTWOOD BENSON PUBLISHING',
            'UNIVERSAL MUSIC-Z TUNES',
            'UNIVERSAL MUSIC',
            'UNIVERSAL MUSIC PUBLISHING BL LIMITED',
            'UNIVERSAL MUSIC CORPORATION',
            'UNIVERSAL MUSIC PUBLISHING (NV)',
            'UNIVERSAL MUSIC PUBL INTERNATIONAL MGB LTD',
            'UNIVERSAL MUSIC PUBLISHING PGM LIMITED',
            'UNIVERSAL MCA MUSIC HOLLAND BV',
            'UNIVERSAL SRG MUSIC PUBLISHING LTD',
            'UNIVERSAL MUSIC PUBLISHING CANADA',
            'UNIVERSAL MUSIC PUBLISHING MGB BRASIL LTDA',
            'UNIVERSAL MUSIC ITALIA SRL',
            'UNIVERSAL/MCA MUSIC PUBLISHING GMBH',
            'UUNIVERSAL MUSIC PUBLISHING GROUP PTY LTD',
            'UNIVERSAL MCA MUSIC PUBLISHING (US)',
            'UNIVERSAL MUSIC PUBLISHING GMBH',
            'UNIVERSAL MUSIC PUBLISHING',
            'UNIVERSAL MUSIC PUBLISHING KOREA',
            'UNIVERSAL MUSIC PUBLISHING LIMITED',
            'UNIVERSAL/MCA MUSIC LIMITED',
            'UNIVERSAL MUSICA UNICA PUBLISHING',
            'UNIVERSAL MUSIC MGB LIMITED',
            'UNIVERSAL/ISLAND MUSIC LIMITED',
            'UNIVERSAL MUSIC PUBLISHING S L',
            'SONGS OF UNIVERSAL INC',
            'UNIVERSAL PUBLISHING PRODUCTION MUSIC GMBH',
        ],
        BMG: [
            'SWMBMGBMI',
            'BMG PRODUCTION MUSIC UK',
            'BMG RIGHTS MANAGEMENT GMBH',
            'BMG KLANGGOLD ZWEI DEUTSCHLAND EDITION',
            'BMG KLANGGOLD DREI DEUTSCHLAND  EDITION',
            'BMG TALPA MUSIC BV',
            'CHRYSALIS MUSIC HOLDINGS GMBH',
            'BMG RIGHTS MANAGEMENT (SCANDINAVIA) AB',
            'BMG VM MUSIC SCANDINAVIA AB',
            'ALTITUDE MUSIC LIMITED',
            'PRIMARY WAVE VANCE MUSIC',
            'BMG PLATINUM SONGS',
            'BMG CICADA',
            'R8D MUSIC PUBLISHING',
            'BMG RIGHTS MANAGEMENT CANADA B',
            'BMG RIGHTS MANAGEMENT BRAZIL LTDA',
            'BMG NILO SPAIN',
            'BMG RIGHTS MANAGEMENT CANADA S',
            'BMG GOLD SONGS',
            'BMG MUSIC PUBLISHING INTERNATIONAL LTD',
            'BUG MUSIC MUSIKVERLAGSGESELLSCHAFT MBH',
            'MAJOR 3RD MUSIC LTD',
            'BMG FIREFLY',
            'BMG PRODUCTION WORKS',
            'CAREERS BMG MUSIC PUBLISHING I',
            'SWMBMGASCAP',
            'BMG KLANGGOLD GERMANY',
            'BMG BUMBLEBEE',
            'BMG KLANGGOLD ZWEI DEUTSCHLAND  EDITION',
            'MUSICDIRECTOR BV',
            'BMG SONGS',
            'BMG RIGHTS ADMINISTRATION SPAIN',
            'BMG RIGHTS MANAGEMENT (BENELUX) B.V.',
            'BMG RIGHTS MANAGEMENT GMBH (GERMANY)',
            'BMG VM MUSIC SPAIN',
            'BMG RIGHTS MANAGEMENT (FRANCE)',
            'BEDS AND BEATS PUBLISHING',
            'BMG ONYX SONGS',
            'BMG KLANGGOLD SCHIBO  EDITION',
            'BMG SILVER SONGS',
            'BMG RIGHTS MANAGEMENT ITALY SR',
            'BMG RIGHTS MANAGEMENT (NETHERLANDS) B.V.',
            'BMG CONSORTIUM MUSIC PUBLISHING ITALY',
            'BEST SOUND EDIZIONI MUSICALI SRL',
            'FRANCIS DREYFUS MUSIC',
            'UNION SQUARE MUSIC SONGS LIMITED',
            'BMG DIAMOND SONGS',
            'BMG FORTY SPAIN',
            'PRIMARY WAVE BEATS',
            'BMG VM MUSIC LIMITED',
            'BMG RIGHTS MANAGEMENT (UK) LIMITED',
            'BMG TALPA MUSIC',
            'BMG RIGHTS MANAGEMENT AUSTRIA',
            'BMG M AND M SPAIN',
            'BBMG MUSIC PUBLISHING',
            'BMG KLANGGOLD SCHWEIZ',
            'PRIMARY WAVE BRIAN',
            'BMG ELEVEN SPAIN',
            'PROMOPUB BV',
            'GREEN AND BLOOM TALENT',
            'J ALBERT AND SON PTY LTD',
            'PRIMARY WAVE ANTHEMS',
            'BMG RIGHTS MANAGEMENT (UK) LTD (HAL DAVID)',
            'BMG RIGHTS MANAGEMENT SCANDINAVIA AB',
            'BMG EGY SPAIN',
            'BMG RIGHTS MANAGEMENT (FRANCE) S.A.R.L',
            'BMG ONYX',
            'BMG CONSORTIUM MUSIC PUBLISHING GERMANY GMBH',
            'BMG CHRYSALISCLIP SPAIN',
            'BMG RIGHTS MANAGEMENT SWITZERLAND',
            'MUSIC BEYOND',
            'STARTING LINEUP MUSIC PUBLISHING EDITION',
            'SUBLIMINAL RECORDS INC',
            'BMG RIGHTS MANAGEMENT (AUSTRALIA) PTY LTD',
            'BMG RIGHTS MANAGEMENT ITALY S.R.L',
            'EXTRAORDINAIRE SONGS',
            'HORNALL BROTHERS MUSIC LTD',
            'BMG KLANGGOLD EINS DEUTSCHLAND EDITION',
            'NANCYLAYNECO LLC',
            'BMG KLANGGOLD EINS DEUTSCHLAND  EDITION',
            'BMG SILVER SONGS US',
            'R8D SONGS',
            'MONTANA EDITION',
            'BMG SONGS INC',
            'BMG VM MUSIC FRANCE',
            'BMG MONARCH',
            'MUST SAVE JANE',
            'WATERFALL MUSIC AS',
            'BMG LOCO SPAIN',
            'BMG RUBY SONGS',
            'MEAT LOCKER PUBLISHING',
            'BMG KLANGGOLD DREI DEUTSCHLAND EDITION',
            'BMG CONSORTIUM MUSIC PUBLISHING GERMANY EDITION',
            'BMG MUSIC PUBLISHING',
            'SUGAR LAKE MUSIC LLC',
            'AFROJACK PUBLISHING',
            'I AM COMPOSING LLC',
            'STAGE THREE MUSIC PUBLISHING LIMITED',
            'EXTRAORDINAIRE MUSIC LLC',
            'BMG TIEMPO SPAIN',
            'BMG VM MUSIC LTD',
            'PLANGENT VISIONS MUSIC LTD',
            'BMG RIGHTS MANAGEMENT (UK) LTD',
            'PRIMARY WAVE SONGS',
            'BMG CONSORTIUM MUSIC BELGIUM',
            'BMG ARIOLA MUENCHEN EDITION',
            'BMG RIGHTS MANAGEMENT SCANDINAVIA',
            'BMG SAPPHIRE SONGS',
            'BMG AM PTY LTD',
            'BMG LIRICA SPAIN',
            'BMG DINSONG LIMITED',
            'BMG KLANGGOLD OESTERREICH',
            'BMG RIGHTS ADMINISTRATION (SPAIN) S.L',
            'BMG RIGHTS MANAGEMENT CANADA A',
            'BMG RM (CHRYSALIS MUSIC) FRANCE',
            'EDITION BMG KLANGGOLD',
            'BMG SWEDEN',
            'BMG RIGHTS MANAGEMENT AND ADMINISTRATION SPAIN SLU',
            'BMG RIGHTS MANAGEMENT (UK) LTD (PRIMARY WAVE)',
            'BMG MUSIC PUBL LTD',
            'BMG PLATINUM SONGS US',
            'BMG MUSIC LTD',
            'BMG BLUE',
            'BMG RIGHTS MANAGEMENT (BENELUX) B.V',
            'EDITION BMG ARIOLA MUENCHEN',
        ],
        SONY: [
            'SONY/ATV COUNTRYSIDE',
            'SONY PUBLISHING (FRANCE)',
            'SONY-ATV DISCOS MUSIC PUBLISHING LLC',
            'EMI PARTNERSHIP MUSIKVERLAG GMBH',
            'WINDSWEPT MUSIC (LONDON) LIMITED',
            'SONY ATV MUSIC PUBLISHING',
            'FAMOUS MUSIC PUBLISHING GERMANY GMBH CO KG',
            'EMI VIRGIN MUSIC INC',
            'SONY/ATV MUSIC PUBLISHING ALLEGRO (UK)',
            'EMI SONGS MUSIKVERLAG GMBH',
            'EMI U CATALOG INC',
            'EMI LONGITUDE MUSIC',
            'EMI MUSIC PUBLISHING (WP) LTD',
            'SONY/ATV MUSIC PUBLISHING ALLEGRO (GERMANY) II EDITION',
            'EMI MUSIC PUBLISHING DENMARK',
            'EMI MUSIC PUBLISHING AUSTRALIA PTY LTD',
            'SONY ATV MUSIC PUBLISHING CANADA',
            'EMI UNITED PARTNERSHIP LTD',
            'EMI SONGS DO BRASIL EDICOES MUSICAIS LTDA',
            'SONY/ATV MUSIC PUBLISHING',
            'SONY/ATV MUSIC PUBLISHING (GERMANY) GMBH',
            'SONY/ATV MUSIC PUBLISHING ALLEGRO (GERMANY) IEDITION',
            'WINDSWEPT EDITION',
            'SONY/ATV MUSIC PUBLISHING ALLEGRO (SCAND) KB',
            'EMI MUSIC PUBLISHING FRANCE',
            'EMI VIRGIN SONGS INC',
            'EMI MUSIC PUBLISHING GERMANY GMBH',
            'SONY ATV ORIXE',
            'EMI VIRGIN MUSIC LTD',
            'SONY/ATV SONGS LLC',
            'EMI MUSIC PUBLISHING LTD (TWENTIETH CENTURY FOX)',
            'SONY ATV TUNES LLC',
            'SONY/ATV MUSIC PUBLISHING SCANDINAVIA KB',
            'EMI TUNES LIMITED',
            'EMI POP MUSIC PUBLISHING',
            'SONY/ATV LATIN MUSIC PUBLISHING LLC',
            'SONY MUSIC PUBL SCANDINAVIA AB',
            'SONY/ATV CROSS KEYS PUBLISHING',
            'SONY ATV SONGS LLC',
            'EMI VIRGIN MUSIC PUBLISHING GERMANY GMBH CO KG',
            'SONY/ATV MUSIC PUB. CANADA',
            'SONY ATV MUSIC PUBLISHING HOLDINGS (SPAIN) LLC S EN C',
            'SONY ATV MUSIC PUBLISHING ALLEGRO FRANCE',
            'EMI MUSIC PUBLISHING ITALIA SRL',
            'SONY/ATV ALLEGRO',
            'SONY/ATV ACUFF ROSE MUSIC',
            'SONY/ATV MUSIC PUBLISHING (UK) LIMITED',
            'EMI MUSIC PUBLISHING SCANDINAVIA AB',
            'SONY/ATV MUSIC PUBLISHING AUSTRALIA PTY LTD',
            'SONY/ATV MUSIC PUBLISHING LLC',
            'EMI SONGS LTD',
            'SONY ATV TREE PUBLISHING',
            'SONY ATV TUNES',
            'EMI MUSIC PUBLISHING (BELGIUM)',
            'SONY/ATV MELODY',
            'SONY/ATV MUSIC PUBLISHING ALLEGRO (GERMANY) I',
            'EMI APRIL MUSIC (CANADA) LTD',
            'EMI HASTINGS CATALOG INC',
            'EMI MUSIC PUBLISHING SPAIN S A',
            'SONY/ATV HARMONY UK',
            'SONY/ATV TIMBER PUBLISHING',
            'EMI ROBBINS CATALOG  INC',
            'SONY/ATV SONGS',
            'SONY MUSIC PUBLISHING CANADA',
            'SONY-ATV MUSIC PUBL (BELGIUM) BV',
            'SONY ATV DANISH SONGS',
            'EMI MUSIC PUBLISHING',
            'MUSIC OF WINDSWEPT',
            'EMI MUSIC PUBLISHING NORWAY AS',
            'EMI MUSIC PUBLISHING LTD',
            'SONY ATV HARMONY',
            'SONY/ATV MUSIC PUBLISHING AUSTRALIA P/L',
            'EMI SONGS MUSIKVERLAG GMBH CO KG',
            'SONY/ATV SONATA',
            'SONY ATV MUSIC PUBLISHING (UK) LIMITED',
            'EMI APRIL MUSIC INC',
            'SONGS OF WINDSWEPT PACIFIC',
            'SONY/ATV STORY MUSIC PUBLISHING',
            'SONY/ATV MUSIC PUBL ALLEGRO (AUST) P/L',
            'EMI SONGS MUSIKVERLAG',
            'EMI MUSIC PUBLISHING LTD (NEW REGENCY PRODUCTIONS)',
            'SONY MUSIC PUBLISHING',
            'SONY/ATV TREE PUBLISHING',
            'SONY/ATV BALLAD',
            'EMI FULL KEEL MUSIC',
            'EMI BLACKWOOD MUSIC INC',
            'SONY-ATV TUNES LLC',
            'EMI TUNES PLC',
            'SONY/ATV MUSIC PUBLISHING KOREA',
            'EMI SONGS ESPANA SRL',
            'SONY ATV',
            'SONY/ATV MUSIC PUBLISHING BV',
            'SONY/ATV POP MUSIC PUBLISHING',
            'SONY ATV SOUNDS LLC',
            'SONY ATV MUSIC PUBLISHING FRANCE',
        ],
        WARNER: [
            'WARNER/CHAPPELL MUSIC GMBH & CO KG',
            'WARNER CHAPPELL MUSIC FINLAND OY',
            'W B M MUSIC',
            'WARNER CHAPPELL MUSIC FRANCE',
            'WARNER-CHAPPELL MUSIC PUBLISHING',
            'WARNER BROS MUSIC LTD',
            'WARNER/CHAPPELL MUSIC AUSTRALIA PTY LTD',
            'WARNER CHAPPELL MUSIC',
            'WARNER BROS MUSIC AUSTRALIA PTY LTD',
            'WARNER BROS INC',
            'WARNER CHAPPELL OVERSEAS HOLDINGS LIMITED',
            'W B MUSIC CORP',
            'WARNER CHAPPELL',
            'WARNER CHAPPELL MUSIC SPAIN S A',
            'WARNER CHAPPELL MUSIC LTD',
            'ARTEMIS MUZIEKUITGEVERIJ B V',
            'WARNER/CHAPPELL MUSIC LTD',
            'WARNER/CHAPPELL MUSIC SCAND AB',
            'WARNER/CHAPPELL UK LIMITED',
            'WARNER CHAPPELL MUSIC IT NA S R L',
            'WARNER / CHAPPELL MUSIC LTD',
            'WARNER CHAPPELL MUSIC HOLLAND BV',
            'WARNER BROS MUSIC',
            'WARNER CHAPPEL MUSIC',
            'WARNER BROS. INC',
            'WARNER BROS MUSIC ITALY SRL',
            'WARNER CHAPPELL MUSIKVERLAG GMBH',
            'WARNER CHAPPELL MUSIC NORWAY AS',
            'WARNER CHAPPELL MUSIC GMBH GERMANY',
            'ARTIST PUBLISHING GROUP WEST',
            'WARNER-CHAPPELL MUSIC CANADA LTD',
            'WARNER CHAPPELL MUSIC INTERNATIONAL LTD',
            'WARNER CHAPPEL MUSIC LTD',
            'WARNER CHAPPELL MUSIC SCANDINAVIA',
            'WARNER CHAPPELL EDICOES MUSICAIS LTDA',
            'WARNER/CHAPPELL MUSIC PUBLISHING LIMITED',
            'ROC NATION MUSIC',
            'WARNER/CHAPPELL NORTH AMERICA LIMITED',
            'WARNER/CHAPPELL MUSIC DENMARK',
            'WARNER MUSIC UK LIMITED',
            'WARNER CHAPPELL PUBLISHING INC',
            'WARNER/CHAPPELL ARTEMIS MUSIC LIMITED',
        ],
        KOBALT: [
            'KOBALT MUSIC SERVICES AUSTRALIA PTY LTD',
            'KOBALT MUSIC NETHERLANDS INTERNATIONAL BV',
            'KOBALT',
            'SONGS OF SMP',
            'KOBALT MUSIC PUBLISHING LIMITED',
            'KOBALT MUSIC SERVICES AMERICA INC',
            'KOBALT MUSIC COPYRIGHTS (UK) LTD',
            'MXM MUSIC AB',
            'KOBALT MUSIC SCANDINAVIA AB',
            'KOBALT MUSIC NETHERLANDS B.V.',
            'KOBALT MUSIC ADMINISTRATION LIMITED',
            'WHERE DA KASZ AT',
            'KOBALT MUSIC COPYRIGHTS SARL',
            'KOBALT MUSIC SERVICES LTD',
            'SONGS MP',
            'KOBALT MUSIC SERVICES AMERICA II INC',
            'KOBALT MUS PUBG LTD CANADA',
            'PRESCRIPTION SONGS',
            'SONGS OF KOBALT MUSIC PUBLISHING',
        ],
    },
};

constants.ShareColors = {
    [constants.EntityType.WRITER]: {
        start: '#6edfdb',
        end: '#71d9f8',
    },
    [constants.EntityType.PUBLISHER]: {
        start: '#80bfff',
        end: '#71d9f8',
    },
    conflict: {
        source: '#FF5B72',
        state: '#22C7F7',
    },
};

constants.ClaimStages = {
    [constants.ClaimRoles.CLAIMANT]: {
        PRE_SUBMIT: 0,
        SUBMITTED: 1,
        EVIDENCE_REJECTED: 2,
        EVIDENCE_APPROVED: 3,
        EVERY_COUNTERPARTY_RESPONDED: 4,
        RESOLVED: 5,
    },
    [constants.ClaimRoles.DEFENDANT]: {
        PRE_RECEIVE: 0,
        RECEIVED: 1,
        RECEIVED_EVIDENCE: 2,
        SUBMITTED: 3,
        EVIDENCE_REJECTED: 4,
        EVIDENCE_APPROVED: 5,
        RESOLVED: 6,
    },
};

constants.SocietyEmails = {
    MSG: { territories: [792], emails: [] },
    SADEMBRA: { territories: [76], emails: [] },
    'AEI-GUATEMALA': { territories: [320], emails: [] },
    'GAI Uz': { territories: [860], emails: [] },
    SUISA: { territories: [756], emails: [] },
    ALBAUTOR: { territories: [8], emails: [] },
    BUMDA: { territories: [466], emails: [] },
    SAIF: { territories: [250], emails: [] },
    ATIDA: { territories: [76], emails: [] },
    'UCMR-ADA': { territories: [642], emails: [] },
    KODA: { territories: [208], emails: [] },
    CMRRA: { territories: [124], emails: [] },
    AAS: { territories: [31], emails: [] },
    ECAD: { territories: [76], emails: [] },
    FILMAUTOR: { territories: [100], emails: [] },
    SCAM: { territories: [250], emails: [] },
    CMC: { territories: [120], emails: [] },
    SGACEDOM: { territories: [214], emails: [] },
    JASRAC: { territories: [392], emails: [] },
    IVARO: { territories: [372], emails: [] },
    SOZA: { territories: [703], emails: [] },
    CSCS: { territories: [124], emails: [] },
    'MASA (RMS)': { territories: [480], emails: [] },
    GESAC: { territories: [56], emails: [] },
    APRA: { territories: [36], emails: [] },
    LAA: { territories: [428], emails: [] },
    SBAT: { territories: [76], emails: [] },
    CPSN: { territories: [524], emails: [] },
    DIRECTORES: { territories: [484], emails: [] },
    SACK: { territories: [410], emails: [] },
    NMPA: { territories: [840], emails: [] },
    ACS: { territories: [826], emails: [] },
    KORRA: { territories: [410], emails: [] },
    ADDAF: { territories: [76], emails: [] },
    SODOMAPLA: { territories: [214], emails: [] },
    MUSICAUTOR: { territories: [100], emails: [] },
    AWGACS: { territories: [36], emails: [] },
    CASH: { territories: [344], emails: [] },
    SIAE: { territories: [380], emails: [] },
    BURAFO: { territories: [528], emails: [] },
    'AKKA-LAA': { territories: [428], emails: [] },
    SAYCO: { territories: [170], emails: [] },
    'BILDRECHT GmbH': { territories: [40], emails: [] },
    GMR: { territories: [840], emails: [] },
    AUTVIS: { territories: [76], emails: [] },
    UFW: { territories: [246], emails: [] },
    SDRM: { territories: [250], emails: [] },
    MCPS: { territories: [826], emails: [] },
    SABAM: { territories: [56], emails: [] },
    ACEMLA: { territories: [630], emails: [] },
    'ACCESS COPYRIGHT': { territories: [124], emails: [] },
    COTT: { territories: [780], emails: [] },
    BSCAP: { territories: [84], emails: [] },
    LatinNet: { territories: [724], emails: [] },
    NASCAM: { territories: [516], emails: [] },
    COSOMA: { territories: [454], emails: [] },
    OTPDA: { territories: [788], emails: [] },
    ROMS: { territories: [643], emails: [] },
    AWA: { territories: [276], emails: [] },
    'Solar EMI': { territories: [276, 826], emails: [] },
    SOMAAP: { territories: [484], emails: [] },
    BSDA: { territories: [686], emails: [] },
    COSGA: { territories: [288], emails: [] },
    KCI: { territories: [360], emails: [] },
    ONDA: { territories: [12], emails: [] },
    MUSIKEDITION: { territories: [40], emails: [] },
    APSAV: { territories: [604], emails: [] },
    LATINAUTOR: { territories: [858], emails: [] },
    SODART: { territories: [124], emails: [] },
    TEOSTO: { territories: [246], emails: [] },
    'MCPS-PRS Alliance': { territories: [826], emails: [] },
    DHFR: { territories: [191], emails: [] },
    'INTL-REP': { territories: [250], emails: [] },
    'BILD-KUNST': { territories: [276], emails: [] },
    SACIM: { territories: [222], emails: [] },
    FONOPERU: { territories: [604], emails: [] },
    AZDG: { territories: [31], emails: [] },
    'GCA (former SSA)': { territories: [268], emails: [] },
    ARGENTORES: { territories: [32], emails: [] },
    SNAC: { territories: [250], emails: [] },
    "Société de l'Image": { territories: [250], emails: [] },
    TEATERAUTOR: { territories: [100], emails: [] },
    AGAYC: { territories: [320], emails: [] },
    APA: { territories: [600], emails: [] },
    EAU: { territories: [233], emails: [] },
    IMRO: { territories: [372], emails: [] },
    SICAM: { territories: [76], emails: [] },
    RSAU: { territories: [646], emails: [] },
    BNDA: { territories: [562], emails: [] },
    SANASTO: { territories: [246], emails: [] },
    SOBODAYCOM: { territories: [68], emails: [] },
    GESTOR: { territories: [203], emails: [] },
    SOCILADRA: { territories: [120], emails: [] },
    SAZAS: { territories: [705], emails: [] },
    SAYCE: { territories: [218], emails: [] },
    SBACEM: { territories: [76], emails: [] },
    SACS: { territories: [690], emails: [] },
    SDCSI: { territories: [372], emails: [] },
    'UNAC-SA': { territories: [24], emails: [] },
    SONGCODE: { territories: [840], emails: [] },
    OFA: { territories: [688], emails: [] },
    ASCAP: { territories: [840], emails: [] },
    SADA: { territories: [300], emails: [] },
    ARTEGESTION: { territories: [218], emails: [] },
    SGAE: { territories: [724], emails: [] },
    SARRAL: { territories: [710], emails: [] },
    MACP: { territories: [458], emails: [] },
    VCPMC: { territories: [704], emails: [] },
    'Polaris Nordic': { territories: [2131], emails: [] },
    SPA: { territories: [620], emails: [] },
    SFF: { territories: [752], emails: [] },
    SAMRO: { territories: [710], emails: [] },
    ARTISJUS: { territories: [348], emails: [] },
    SOCINPRO: { territories: [76], emails: [] },
    AKM: { territories: [40], emails: [] },
    ACAM: { territories: [188], emails: [] },
    TONO: { territories: [578], emails: [] },
    CAPASSO: { territories: [710], emails: [] },
    PROLITTERIS: { territories: [756], emails: [] },
    ACUM: { territories: [376], emails: [] },
    'ATHINA- SADA - S.A.D.A.': { territories: [300], emails: [] },
    ECCO: { territories: [662], emails: [] },
    'CIS-Net AVI': { territories: [250], emails: [] },
    BURIDA: { territories: [384], emails: [] },
    ADAGP: { territories: [250], emails: [] },
    'SFP-ZAPA': { territories: [616], emails: [] },
    'PAM CG': { territories: [499], emails: [] },
    OSA: { territories: [203], emails: [] },
    BUTODRA: { territories: [768], emails: [] },
    AsDAC: { territories: [498], emails: [] },
    ABYROY: { territories: [398], emails: [] },
    LVG: { territories: [40], emails: [] },
    DAMA: { territories: [724], emails: [] },
    ODDA: { territories: [262], emails: [] },
    SPAC: { territories: [591], emails: [] },
    SPACQ: { territories: [124], emails: [] },
    'DIRECTORS UK': { territories: [826], emails: [] },
    SETEM: { territories: [792], emails: [] },
    'AuPO CINEMA': { territories: [804], emails: [] },
    SCD: { territories: [152], emails: [] },
    DILIA: { territories: [203], emails: [] },
    'SESAC Inc.': { territories: [840], emails: [] },
    Kyrgyzpatent: { territories: [417], emails: [] },
    AGADU: { territories: [858], emails: [] },
    UACRR: { territories: [804], emails: [] },
    COSOTA: { territories: [834], emails: [] },
    SOCINADA: { territories: [120], emails: [] },
    'HDS-ZAMP': { territories: [191], emails: [] },
    MESAM: { territories: [792], emails: [] },
    'ZAMP - Macédoine': { territories: [807], emails: [] },
    WGJ: { territories: [392], emails: [] },
    SARTEC: { territories: [124], emails: [] },
    BUCADA: { territories: [140], emails: [] },
    HAA: { territories: [191], emails: [] },
    TALI: { territories: [376], emails: [] },
    AACIMH: { territories: [340], emails: [] },
    NICAUTOR: { territories: [558], emails: [] },
    SACENC: { territories: [250], emails: [] },
    SSA: { territories: [756], emails: [] },
    SACERAU: { territories: [818], emails: [] },
    KazAK: { territories: [398], emails: [] },
    ZPAP: { territories: [616], emails: [] },
    'APG-Japan': { territories: [392], emails: [] },
    SOPE: { territories: [300], emails: [] },
    MRS: { territories: [826], emails: [] },
    AMCOS: { territories: [36], emails: [] },
    DAC: { territories: [32], emails: [] },
    SGA: { territories: [624], emails: [] },
    MCSN: { territories: [566], emails: [] },
    VEVAM: { territories: [528], emails: [] },
    MRCSN: { territories: [524], emails: [] },
    UBC: { territories: [76], emails: [] },
    HFA: { territories: [840], emails: [] },
    'MIS@ASIA': { territories: [702], emails: [] },
    SGDL: { territories: [250], emails: [] },
    AMRA: { territories: [840], emails: [] },
    ICG: { territories: [840], emails: [] },
    UPRS: { territories: [800], emails: [] },
    BONO: { territories: [578], emails: [] },
    BMDA: { territories: [504], emails: [] },
    ARMONIA: { territories: [250], emails: [] },
    AUTORARTE: { territories: [862], emails: [] },
    KOPIOSTO: { territories: [246], emails: [] },
    FILMJUS: { territories: [348], emails: [] },
    SOCAN: { territories: [124], emails: [] },
    SPACEM: { territories: [250], emails: [] },
    ACCS: { territories: [780], emails: [] },
    DBCA: { territories: [76], emails: [] },
    IPRS: { territories: [356], emails: [] },
    SOFAM: { territories: [56], emails: [] },
    BBDA: { territories: [854], emails: [] },
    ZAIKS: { territories: [616], emails: [] },
    JACAP: { territories: [388], emails: [] },
    BUMA: { territories: [528], emails: [] },
    BeAT: { territories: [96], emails: [] },
    UPRAVIS: { territories: [643], emails: [] },
    SACD: { territories: [250], emails: [] },
    RAO: { territories: [643], emails: [] },
    BEELDRECHT: { territories: [528], emails: [] },
    ALCS: { territories: [826], emails: [] },
    VEGAP: { territories: [724], emails: [] },
    SAGCRYT: { territories: [484], emails: [] },
    CSI: { territories: [250], emails: [] },
    AIPA: { territories: [705], emails: [] },
    CELAS: { territories: [276, 826], emails: [] },
    ADAVIS: { territories: [192], emails: [] },
    BCDA: { territories: [178], emails: [] },
    SESAM: { territories: [250], emails: [] },
    PICTORIGHT: { territories: [528], emails: [] },
    SOMAS: { territories: [508], emails: [] },
    SACEM: { territories: [250], emails: [] },
    JASPAR: { territories: [392], emails: [] },
    SODRAC: { territories: [124], emails: [] },
    'WID Centre': { territories: [840], emails: [] },
    SINEBIR: { territories: [792], emails: [] },
    SOGEM: { territories: [484], emails: [] },
    'FastTrack DCN': { territories: [250], emails: [] },
    SLPRS: { territories: [144], emails: [] },
    MCSC: { territories: [156], emails: [] },
    STEMRA: { territories: [528], emails: [] },
    AMUS: { territories: [70], emails: [] },
    'UFFICIO GIURIDICO': { territories: [336], emails: [] },
    KUVASTO: { territories: [246], emails: [] },
    GHAMRO: { territories: [288], emails: [] },
    NCB: { territories: [208], emails: [] },
    ASDACS: { territories: [36], emails: [] },
    "The Author's Registry Inc.": { territories: [840], emails: [] },
    SADAIC: { territories: [32], emails: [] },
    COSON: { territories: [566], emails: [] },
    STEF: { territories: [352], emails: [] },
    SACVEN: { territories: [862], emails: [] },
    WGA: { territories: [840], emails: [] },
    KOSA: { territories: [410], emails: [] },
    DRCC: { territories: [124], emails: [] },
    SACEMLUXEMBOURG: { territories: [442], emails: [] },
    IMJV: { territories: [528], emails: [] },
    PROCAN: { territories: [124], emails: [] },
    CISAC: { territories: [250], emails: [] },
    HUNGART: { territories: [348], emails: [] },
    'ICE Services AB': { territories: [752], emails: [] },
    'LATGA-A': { territories: [440], emails: [] },
    'Bildupphovsrätt (Visual Copyright Society)': { territories: [752], emails: [] },
    PAPPRI: { territories: [360], emails: [] },
    SADIA: { territories: [24], emails: [] },
    MCSK: { territories: [404], emails: [] },
    CARCC: { territories: [124], emails: [] },
    MCT: { territories: [764], emails: [] },
    'ZAMP Association of Slovenia': { territories: [705], emails: [] },
    AMPAL: { territories: [36], emails: [] },
    'AUSTRO-MECHANA (AUME)': { territories: [40], emails: [] },
    'COPY-DAN BILLEDER': { territories: [208], emails: [] },
    DASC: { territories: [170], emails: [] },
    ANACIM: { territories: [76], emails: [] },
    SADH: { territories: [300], emails: [] },
    DACS: { territories: [826], emails: [] },
    'ARMAUTHOR NGO': { territories: [51], emails: [] },
    NCIP: { territories: [112], emails: [] },
    COSCAP: { territories: [52], emails: [] },
    MACA: { territories: [446], emails: [] },
    SABEM: { territories: [76], emails: [] },
    DGA: { territories: [840], emails: [] },
    REDES: { territories: [170], emails: [] },
    SDADV: { territories: [20], emails: [] },
    CA: { territories: [36], emails: [] },
    COLCCMA: { territories: [158], emails: [] },
    SOKOJ: { territories: [499, 688], emails: [] },
    SQN: { territories: [70], emails: [] },
    BUBEDRA: { territories: [204], emails: [] },
    DIVA: { territories: [344], emails: [] },
    GEMA: { territories: [276], emails: [] },
    ZAMCOPS: { territories: [894], emails: [] },
    RUR: { territories: [643], emails: [] },
    VDFS: { territories: [40], emails: [] },
    VISCOPY: { territories: [36], emails: [] },
    ASSIM: { territories: [76], emails: [] },
    OMDA: { territories: [450], emails: [] },
    'The Society of Authors (SOA)': { territories: [826], emails: [] },
    'Solar Sony': { territories: [276, 826], emails: [] },
    FILSCAP: { territories: [608], emails: [] },
    ACDAM: { territories: [192], emails: [] },
    COMPASS: { territories: [702], emails: [] },
    LIRA: { territories: [528], emails: [] },
    ATN: { territories: [152], emails: [] },
    SUISSIMAGE: { territories: [756], emails: [] },
    MusicMark: { territories: [840], emails: [] },
    MÜST: { territories: [158], emails: [] },
    'LITERAR-MECHANA': { territories: [40], emails: [] },
    ZIMURA: { territories: [716], emails: [] },
    AUTODIAHIRISI: { territories: [300], emails: [] },
    ARS: { territories: [840], emails: [] },
    APDAYC: { territories: [604], emails: [] },
    AMAR: { territories: [76], emails: [] },
    IDA: { territories: [250], emails: [] },
    ABRAC: { territories: [76], emails: [] },
    KOMCA: { territories: [410], emails: [] },
    WAMI: { territories: [360], emails: [] },
    AEPI: { territories: [300], emails: [] },
    CREAIMAGEN: { territories: [152], emails: [] },
    DALRO: { territories: [710], emails: [] },
    CAPAC: { territories: [124], emails: [] },
    BMI: { territories: [840], emails: [] },
    LITA: { territories: [703], emails: [] },
    SACM: { territories: [484], emails: [] },
    SASUR: { territories: [740], emails: [] },
    CHA: { territories: [158], emails: [] },
    CopyRo: { territories: [642], emails: [] },
    SAVA: { territories: [32], emails: [] },
    MOSCAP: { territories: [496], emails: [] },
    'NORD-DOC': { territories: [752], emails: [] },
    ABRAMUS: { territories: [76], emails: [] },
    VAGA: { territories: [840], emails: [] },
    'VG WORT': { territories: [276], emails: [] },
    BGDA: { territories: [324], emails: [] },
    STIM: { territories: [752], emails: [] },
    PRS: { territories: [826], emails: [] },
};

export default constants;
